import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { t } from "@/i18n-js/instance";
import { useOtpStyles } from "./useOtpStyles";

interface OTPInputProps {
  containerWidth?: number;
  disabled?: boolean;
  error?: boolean;
  onComplete?: (otp: string) => void;
  onValueChange?: (otp: string) => void;
}

export const OTPInput = ({
  onComplete,
  onValueChange,
  disabled = false,
  error = false,
  containerWidth = 0,
}: OTPInputProps) => {
  const [otp, setOtp] = useState("");
  const { containerStyle, inputStyle, focusStyle, separatorWidth } =
    useOtpStyles({ disabled, error, width: containerWidth });

  const handleChange = (value: string) => {
    setOtp(value);
    onValueChange?.(value);

    if (value.length === 6) {
      onComplete?.(value);
    }
  };

  useEffect(() => {
    if (error) {
      setOtp("");
    }
  }, [error]);

  return (
    <div style={containerStyle}>
      <fieldset className="contents">
        <legend className="sr-only">{t("otp.input.legend")}</legend>
        <OtpInput
          value={otp}
          onChange={handleChange}
          numInputs={6}
          separator={<span style={{ width: `${separatorWidth}px` }} />}
          isInputNum
          shouldAutoFocus={!disabled}
          inputStyle={inputStyle}
          focusStyle={focusStyle}
          containerStyle={containerStyle}
          isDisabled={disabled}
        />
      </fieldset>
    </div>
  );
};
